<div class="checkbox-div pl-3" [class.ng-invalid]="!hiddenControl.valid && !readonly && touched" [class.ng-valid]="(hiddenControl.valid && !readonly) || !touched">
    <div *ngIf="schema.obrigatorio && !readonly" class="label-chsckbox">*</div>
    <mat-checkbox *ngIf="opcoes.length > 2" #checkAllOptions [value]="null" [checked]="allChecked" [disabled]="readonly" [color]="'primary'" (change)="selectAll($event.checked)">Selecionar
        Todos
    </mat-checkbox>
    <ul class="checkbox">
        <li *ngFor="let opcao of opcoes;let i = index">
            <mat-checkbox [color]="'primary'" [formControl]="checkboxControls.controls[i]"
                          (change)="checkboxChange($event.checked,opcao.key,i)">{{opcao.displayName}}</mat-checkbox>
        </li>
    </ul>
</div>